import store from 'app/store';
import AppConstants from 'general/constants/AppConstants';
import { t } from 'i18next';
import { thunkGetCommissionTransactionList } from './commissionTransactionSlice';

const CommissionTransactionHelper = {
    // ---- methods ----
    callApiGetAgencyTransactionList: (params) => {
        store.dispatch(thunkGetCommissionTransactionList({ params }));
    },

    // lay mau trang thai dai ly
    getAgencyStatusColor: (status) => {
        switch (status) {
            case AppConstants.agencyStatus.normal:
                return 'success';
            case AppConstants.agencyStatus.signed:
                return 'info';
            case AppConstants.agencyStatus.suspended:
                return 'gray';
            case AppConstants.agencyStatus.deleted:
                return 'danger';
            case AppConstants.agencyStatus.registered:
                return 'info';
            case 'AVAILABLE':
                return 'success'
            default:
                return 'warning';
        }
    },

    // lay mau trang thai ban hang
    getSaleStatusColor: (status) => {
        switch (status) {
            case AppConstants.saleStatus.ordered:
                return 'info';
            case AppConstants.saleStatus.shipping:
                return 'warning';
            case AppConstants.saleStatus.installing:
                return 'danger';
            case AppConstants.saleStatus.installed:
                return 'danger';
            case AppConstants.saleStatus.completed:
                return 'success';
            default:
                return 'warning';
        }
    },

    // lay mau trang thai hoa don tien dien
    getLandownerElectricityBillColor: (status) => {
        switch (status) {
            case AppConstants.energyBillStatus.validated:
                return 'success';
            case AppConstants.energyBillStatus.pending:
                return 'warning';
            default:
                return 'warning';
        }
    },

    // filter vai tro
    filterRoleOptions: () => {
        return [
            { name: t('all'), value: '' },
            {
                name: t('agencyRoleDropdownTitle_' + AppConstants.userAgencyType.sale),
                value: AppConstants.userAgencyType.sale,
            },
            {
                name: t('agencyRoleDropdownTitle_' + AppConstants.userAgencyType.investor),
                value: AppConstants.userAgencyType.investor,
            },
            {
                name: t('agencyRoleDropdownTitle_' + AppConstants.userAgencyType.group),
                value: AppConstants.userAgencyType.group,
            },
            {
                name: t('agencyRoleDropdownTitle_' + AppConstants.userAgencyType.landlord),
                value: AppConstants.userAgencyType.landlord,
            },
        ];
    },

    // filter trang thai ban hang
    filterSaleStatusOptions: () => {
        return [
            { name: t('all'), value: '' },
            {
                name: t('saleStatus_' + AppConstants.saleStatus.ordered),
                value: AppConstants.saleStatus.ordered,
            },
            {
                name: t('saleStatus_' + AppConstants.saleStatus.shipping),
                value: AppConstants.saleStatus.shipping,
            },
            {
                name: t('saleStatus_' + AppConstants.saleStatus.installing),
                value: AppConstants.saleStatus.installing,
            },
            {
                name: t('saleStatus_' + AppConstants.saleStatus.installed),
                value: AppConstants.saleStatus.installed,
            },
            {
                name: t('saleStatus_' + AppConstants.saleStatus.completed),
                value: AppConstants.saleStatus.completed,
            },
        ];
    },

    // filter loai dai ly
    filterAgencyTypeOptions: () => {
        return [
            { name: t('all'), value: '' },
            {
                name: t('accountType_' + AppConstants.accountType.individual),
                value: AppConstants.accountType.individual,
            },
            {
                name: t('accountType_' + AppConstants.accountType.organization),
                value: AppConstants.accountType.organization,
            },
        ];
    },

    formatAgencyTransactionCode: (agencyTransactionId) => {
        const prefix = 'DL';
        const formattedId = agencyTransactionId;
        return `${formattedId}`;
    },

    formatInvestorCode: (investorId) => {
        const prefix = 'NĐT';
        const formattedId = investorId;
        return `${formattedId}`;
    },
};

export default CommissionTransactionHelper;
